module.exports = __webpack_public_path__ + "assets/img/search_4.14e023f0.png";